import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/content");
            setContent(data);
        } catch (e) {
            console.error("content load error", e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const save = async (updates) => {
        const { data } = await api.put("/content", updates);
        setContent(data);
        return data;
    };

    return (
        <ContentContext.Provider value={{ content, loading, refresh, save, setContent }}>
            {children}
        </ContentContext.Provider>
    );
};

export const useContent = () => useContext(ContentContext);
